import React, { Component } from "react"
import { Form, Input, Icon, Button, message } from "antd"
import { observer } from "mobx-react"
import { observable, action } from "mobx"
const FormItem = Form.Item

@observer
export default class extends Component {
  @observable info = {
    oldpassword: "",
    newpassword: ""
  }

  @action
  changeForm = (e, field) => this.loginInfo[field] = e.target.value

  resetPassword() {
    const { auth } = this.props
    auth.resetPassword(this.info)
    .then(() => {
      auth.updateFormType("login")
    }, error => message.error(error.message))
  }

  render() {
    return (
      <section>
        <Form>
          <div>
          <FormItem>
            <Icon type="lock" />
            <Input size="large"
              placeholder="新密码"
              type="password" value={this.info.oldpassword}
              name="newPassword"
              onChange={(e)=>this.handleChange(e,"newPassword")} />
          </FormItem>
          <FormItem>
            <Icon type="lock" />
            <Input size="large"
              placeholder="确认新密码" type="password"
              value={this.info.newpassword} name="newPassword2"
              onChange={(e)=>this.handleChange(e,"newPassword2")} />
          </FormItem>
          <FormItem>
            <Button size="large"
              type="primary" htmlType="submit"
              onClick={() => this.resetPassword()}>重置</Button>
          </FormItem>
          </div>
        </Form>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/containers/ResetPassword.js